import styled from "styled-components";
import { colours } from "../../styles/colours.constants";

export const Button = styled.button`
	background: none;
	border: none;
	outline: none;
	margin: 0;
	padding: 0;
	cursor: pointer;

	&:disabled {
		cursor: not-allowed;
		svg {
			fill: ${colours.greyDark};
		}
	}

	&:hover:not(:disabled) {
		svg {
			fill: ${colours.red};
		}
	}
`;
